import Vue from 'vue'
import config from '@/configurations/config-environment'
import arrayUtils from '@/utils/arrayUtils'
import { BaseService } from '../baseService'

const dataws = config.apis.dataws

export class FinishingsService extends BaseService {
  getFinishings(projectID, measurementpointGuid) {
    const authorisation = this.getAuthorizationObject()
    const languageCode = this.getLangCodeLongFromShort(authorisation.Language)
    const data = {
      Authorisation: authorisation,
      LanguageCode: languageCode,
      WebserviceVersion: '1.0',
      TypeOfExport: 'Export_FIELD_JSON_v1_0_0',
      Parameters: [
        {
          ParameterType: 'ExportFormat',
          StringValue: 'json'
        },
        {
          ParameterType: 'ProjectID',
          StringValue: projectID.toString(),
          FloatValue: projectID.toString()
        },
        {
          ParameterType: 'MeasurementPointGuid',
          StringValue: measurementpointGuid.toString()
        }
      ],
      logFormat: 'XML'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/GetFinishings`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'getFinishings')

        const veldData = JSON.parse(resp.data.Files[0].FileContent).VeldData
        const tblMeasurementPoints = arrayUtils.formatArray(veldData.tblMeasurementPoints)
        const tblFinishings = arrayUtils.formatArray(veldData.tblFinishings)

        return {
          tblMeasurementPoints,
          tblFinishings
        }
      })
  }

  setFinishings(prid, mpguid, finishings) {
    const data = {
      data: {
        PrID: prid,
        MpGuid: mpguid,
        Finishings: finishings,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'UPDATE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetFinishings`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        if (resp.status !== 200 || resp.data.ResultCode !== 'Import_Succes') throw new Error(`Unable to save finishings. ${resp.data.ResultMessage}`)

        let tblFinishings = JSON.parse(resp.data.FileContent).VeldData.tblFinishings
        tblFinishings = arrayUtils.formatArray(tblFinishings)
        return tblFinishings
      })
  }

  createFinishing(projectId, measurementPointGuid, finishings) {
    const data = {
      data: {
        PrID: projectId,
        MpGuid: measurementPointGuid,
        Finishings: finishings,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'INSERT'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetFinishings`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'createFinishing')

        let tblFinishings = JSON.parse(resp.data.FileContent).VeldData.tblFinishings
        tblFinishings = arrayUtils.formatArray(tblFinishings)
        return tblFinishings
      })
  }

  updateFinishings(projectId, measurementPointGuid, finishings) {
    const data = {
      data: {
        PrID: projectId,
        MpGuid: measurementPointGuid,
        Finishings: finishings,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'UPDATE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetFinishings`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        if (resp.status !== 200 || resp.data.ResultCode !== 'Import_Succes') throw new Error(`Unable to save finishings. ${resp.data.ResultMessage}`)

        let tblFinishings = JSON.parse(resp.data.FileContent).VeldData.tblFinishings
        tblFinishings = arrayUtils.formatArray(tblFinishings)
        return tblFinishings
      })
  }

  deleteFinishings(projectId, measurementPointGuid, finishingGuid) {
    const data = {
      data: {
        PrID: projectId,
        MpGuid: measurementPointGuid,
        FiGuid: finishingGuid,
        Authorisation: this.getAuthorizationObject()
      },
      action: 'DELETE'
    }

    return Vue.http
      .post(`${dataws}ITWDataRestService_V1_0/SetFinishings`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((resp) => {
        this.evaluateResponse(resp, 'deleteFinishings')

        return true
      })
  }

  evaluateResponse(response, requestName) {
    if (
      response.status !== 200 ||
      !response.data ||
      (response.data.ResultCode !== 'Import_Succes' && response.data.ResultCode !== 'Export_Succes') ||
      (response.data.ResultMessage !== null && response.data.ResultMessage.toLowerCase().includes('error'))
    ) {
      throw new Error(`Request ${requestName} failed with message '${response.data.ResultMessage}'`)
    }
  }
}
